
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 25 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.635 11.16l-4.517-8.17a.97.97 0 01-.022-.876.823.823 0 01.275-.326.678.678 0 01.38-.121h4.561c.253 0 .501.074.723.215.22.141.407.344.542.59l4.3 7.768c.153.277.234.598.234.926 0 .329-.08.65-.234.927l-4.3 7.768a1.613 1.613 0 01-.543.59c-.22.14-.47.215-.722.215h-4.56a.678.678 0 01-.383-.12.823.823 0 01-.275-.328.972.972 0 01.024-.878l4.517-8.18zm-11.394 0L1.724 2.994a.971.971 0 01-.024-.879.823.823 0 01.275-.327.678.678 0 01.382-.12h4.56c.253 0 .502.074.723.215.221.14.408.344.543.59l4.3 7.768c.153.277.234.598.234.926 0 .329-.08.65-.234.927l-4.3 7.768c-.135.246-.322.45-.543.59a1.35 1.35 0 01-.723.215h-4.56a.678.678 0 01-.382-.12.822.822 0 01-.275-.328.971.971 0 01.024-.878l4.517-8.18z","stroke":"#5C6970","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    